export default "__VITE_ASSET__B0GP2WFw__"